<template>
<svg xmlns="http://www.w3.org/2000/svg" width="19" height="20" viewBox="0 0 19 20" fill="none">
<rect x="0.5" y="1" width="18" height="18" rx="2.5" stroke="black"/>
</svg>
</template>